import React, { useState } from "react";
import { cancelOrderPostApi } from "../../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
import Button from "../../../Button/Button";
import Style from "./CancleOrder.module.scss";
const CancleOrder = ({ handleSure, rawInfo }) => {

  const [describ, setDescrib] = useState("");
  const [status, setStatus] = useState("");
  const [disable, setDisable] = useState(false);
  const sendInfo = () => {
    setDisable(true);
    let info = {
      order_id: rawInfo.orderNumber,
      status: status,
      cause: describ,
      supplier_id: 0,
    };
    cancelOrderPostApi(info, (suc) => {
      if (suc.status === 1) {
        succToast(suc.message);
        setDisable(false);
      } else {
        errorToast(suc.message);
        setDisable(false);
      }
    });
  };
  return (
    <div className={Style.componentHolder}>
      <div className={Style.inputsHolder}>
      <p className={Style.by}>توسط:</p>
        <label className={Style.radioTarget} htmlFor="customer">
          مشتری
        </label>
        <input
          value={"-1"}
          onChange={(e) => setStatus(e.target.value)}
          id={"customer"}
          type={"radio"}
          name="by"
        />
        <label className={Style.radioTarget} htmlFor="supplier">
          تامین کننده
        </label>
        <input
          value={"-2"}
          onChange={(e) => setStatus(e.target.value)}
          id={"supplier"}
          type={"radio"}
          name="by"
        />
      </div>
      <label className={Style.reasonTarget} htmlFor="reason">
        ذکر دلیل
      </label>
      <textarea
        value={describ}
        onChange={(e) => setDescrib(e.target.value)}
        className={Style.description}
        id={"reason"}
      />
      <div className={Style.btnHolder}>
        <Button
          ClickHandler={sendInfo}
          Value="ارسال"
          ClassBtn="sendBtn"
          disabledProps={disable}
        />
        <Button ClickHandler={handleSure} Value="بستن" ClassBtn="okBtn" />
      </div>
    </div>
  );
};

export default CancleOrder;
